<template>
    <div class="ques-search-wrapper">
        <Select
            :initValue="currentId"
            :options="questionOptions"
            :config="{ noPopup: true }"
            class="question-select"
            @selectClick="selectClick"
            v-show="!hideSelect"
        />
        <div class="question-search-panel" :class="{ 'no-selected-search': hideSelect }" v-show="hasShowPanel">
            <Search :placeholder="palceHolder" @searchChange="searchChange" @inputChange="searchChange" class="question-search" />
            <QuestionList
                :questions="questions"
                :keyWord="searchText"
                :isLoading="isLoading"
                class="question-list"
                @itemSelected="itemChange"
                @scrollToBottom="toBottomHandler"
            />
        </div>
    </div>
</template>

<script>
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import QuestionList from "./QuestionList";
import { debounce } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

export default {
    name: "QuestionSearch",
    components: {
        Select,
        Search,
        QuestionList
    },
    props: ["question", "questionId", "hideSelect","firstScreenQuesInitLang"],
    data() {
        return {
            isShowPanel: false,
            currentId: this.questionId || "def",
            questions: [],
            pageIdx: 1, // 从1开始
            pageSize: 20,
            searchText: "",
            hasMore: true,
            isLoading: false
        };
    },
    computed: {
        questionOptions() {
            return [
                {
                    label: this.question || this.$t("zhiji.answer.linkQuestion"),
                    value: this.questionId || "def"
                }
            ];
        },
        palceHolder() {
            return this.$t("zhiji.common.inputHolderLabel");
        },
        hasShowPanel() {
            if (this.hideSelect || this.isShowPanel) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.gameState[propName];
        },
        searchChange(data) {
            this.searchText = this.zhiji.strTrim(data.value);
            this.pageIdx = 1;
            this.hasMore = true;
            this.queryHanlder();
        },
        queryQuestions() {
            this.isLoading = true;

            this.hasMore &&
                this.searchText &&
                this.zhiji
                    .requestByServiceName("queryQuestionByName", {
                        pageIdx: this.pageIdx,
                        pageSize: this.pageSize,
                        searchText: this.searchText
                    })
                    .then(resp => {
                        this.isLoading = false;
                        this.hasMore = resp.hasMore;
                        this.pageIdx == 1 ? this.questions.splice(0, this.questions.length, ...resp.quesList) : this.questions.push(...resp.quesList);
                    })
                    .catch(() => (this.isLoading = false));
        },
        selectClick(data) {
            this.$store.dispatch("zhiji/showModal", {
                type: "QuestionSelectorTableModal",
                data: {
                    title: i18n.t("zhiji.answer.textWidget.linkQuestion"),
                    questionId: parseInt(this.questionId),
                    currentLang: this.questionId ?  this.getStorePorp("defaultLang") : this.firstScreenQuesInitLang,
                    confirm: data => {
                        this.itemChange(data);
                    }
                }
            });
        },
        itemChange(item) {
            this.questionOptions.splice(0, 1, {
                label: item.question,
                value: item.questionId
            });
            this.isShowPanel = false;
            this.currentId = item.questionId;

            this.$emit("questionSelected", item);
        },
        toBottomHandler() {
            if (!this.hasMore) {
                return;
            }

            this.pageIdx++;

            this.queryQuestions();
        },
        windowClick(event) {
            if (this.zhiji.isClickOuter(event, "ques-search-wrapper")) {
                this.isShowPanel = false;
                this.$emit("close");
            }
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
        this.queryHanlder = debounce(() => {
            this.queryQuestions();
        }, 500);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    }
};
</script>

<style lang="less" scoped>
.ques-search-wrapper {
    width: 304px;
    display: inline-block;
    position: relative;
    margin-bottom: 6px;

    .question-select {
        width: 100%;
        background: #fff;
    }

    .question-search-panel {
        width: 100%;
        position: absolute;
        left: 0;
        top: 42px;
        background: #fff;
        box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
        border-radius: 4px;
        z-index: 2;
        .search-wrapper {
            padding: 7px 0;
        }
    }

    .no-selected-search {
        top: 5px;
    }

    .question-search {
        width: 100%;
        border-left-width: 0;
        border-right-width: 0;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
}
</style>
